/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * テキスト配置
 * @export
 */
export const TextAlignment = {
    Left: 'left',
    Center: 'center',
    Right: 'right'
};
export function TextAlignmentFromJSON(json) {
    return TextAlignmentFromJSONTyped(json, false);
}
export function TextAlignmentFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TextAlignmentToJSON(value) {
    return value;
}
